/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Generation_ErrorInputs */

const en_read_along_ai_generation_error = /** @type {(inputs: Read_Along_Ai_Generation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This feature is temporarily unavailable. Please try again soon or contact support.`)
};

const es_read_along_ai_generation_error = /** @type {(inputs: Read_Along_Ai_Generation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta función no está disponible temporalmente. Inténtalo de nuevo pronto o contacta con soporte.`)
};

/**
* | output |
* | --- |
* | "This feature is temporarily unavailable. Please try again soon or contact support." |
*
* @param {Read_Along_Ai_Generation_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_generation_error = /** @type {((inputs?: Read_Along_Ai_Generation_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Generation_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_generation_error(inputs)
	return en_read_along_ai_generation_error(inputs)
});